import {loopTrackerStore} from './loop_tracker.js';
import {ingestsStore} from './ingests.js';

export const audienceStore = {
  loopTracker: loopTrackerStore,
  ingests: ingestsStore,
};
